import { http } from '../../config/axios'

export default function patchNotificacaoFaturaService(id: string, inativo: boolean): Promise<void> {
  return http
    .patch('/api/notificacao-fatura/' + id, { inativo })
    .then((r) => r.data)
    .catch((error) => {
      console.error('Erro ao alterar status da notificação de fatura', error)
      throw Error(error.response?.data)
    })
}
